import { ChevronDown } from 'lucide-react'
import { useRef } from 'react'

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu'
import {
  anyFilterOn,
  filtersAfterPicking,
  NO_FILTERS,
  yearIsShown,
} from '../mapView'
import { pickedSpanName, STRETCH_HINT, type YearPickerProps } from './yearPick'

// The same choice folded into one button. A click picks and closes; a shift-click keeps the menu
// open so the span can be stretched again.
export const YearMenu = ({ years, filters, onFilters }: YearPickerProps) => {
  const everything = !anyFilterOn(filters)
  // Radix runs onClick before onSelect, and only onClick knows whether shift was held.
  const stretching = useRef(false)
  const closeUnlessStretching = (event: Event) => {
    if (stretching.current) event.preventDefault()
  }

  return (
    // Not modal: a modal menu locks the whole page, which restyles every map cell on open.
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        aria-label="Years shown on the map"
        title={STRETCH_HINT}
        className="group/years flex h-7 shrink-0 cursor-pointer items-center gap-1.5 rounded-md border bg-white px-2.5 text-xs font-medium tabular-nums outline-none transition-colors hover:bg-neutral-50 focus-visible:ring-2 focus-visible:ring-neutral-900"
      >
        {pickedSpanName(filters)}
        <ChevronDown className="size-3 opacity-50 transition-opacity group-hover/years:opacity-100 group-data-[state=open]/years:opacity-100" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-96 min-w-44">
        <DropdownMenuCheckboxItem
          checked={everything}
          onClick={() => onFilters(NO_FILTERS)}
        >
          All years
        </DropdownMenuCheckboxItem>
        <DropdownMenuSeparator />
        {years.map((year) => (
          <DropdownMenuCheckboxItem
            key={year}
            checked={!everything && yearIsShown(year, filters)}
            onSelect={closeUnlessStretching}
            onClick={(event) => {
              stretching.current = event.shiftKey
              onFilters(filtersAfterPicking(year, event.shiftKey, filters))
            }}
            className="tabular-nums"
          >
            {year}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
